import { useState, useEffect } from "react";
import { API } from "../App";

const EMPTY = { total: 0, orders: 0, direct: 0, pro: 0, franchise: 0 };

/** Polls GET /api/chat/unread-total to drive WhatsApp-style unread badges. */
export default function useUnreadChats(intervalMs = 25000) {
  const [counts, setCounts] = useState(EMPTY);

  useEffect(() => {
    let cancelled = false;
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        const r = await fetch(`${API}/chat/unread-total`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) return;
        const d = await r.json();
        if (!cancelled) setCounts({ ...EMPTY, ...d });
      } catch {
        /* silent */
      }
    };
    fetchCounts();
    const iv = setInterval(fetchCounts, intervalMs);
    window.addEventListener("focus", fetchCounts);
    return () => {
      cancelled = true;
      clearInterval(iv);
      window.removeEventListener("focus", fetchCounts);
    };
  }, [intervalMs]);

  return counts;
}
